export const formatAsCurrency = (amount) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
  return formatter.format(amount);
};

export const formatNumCommas = (num) => {
    return num.toLocaleString("en-US");
}

// return 0 if NaN or infinite
export const finiteOrZero = (num) => {
  let newNum
  Number.isFinite(num) ? newNum = num  : newNum =  0; 
  return newNum;
}